import rill from "rill";
import set from "@rill/set";

import controller from "./exercise-library-controller.js";
import catalogController from "./catalog-controller";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions.js";

const ExerciseLibrary = (app) => {
  app.at(
    "/exercise-library/*",
    rill()
      .use(set("heading", ["Coaching", "Exercise Library"]))
      .setup((app) => {
        app.get(
          "/",
          (ctx, next) =>
            checkOrganizationSectionPermission(
              ctx,
              next,
              ["Exercise Library"],
              "/coaching-portal/athletes"
            ),
          controller
        );
      })
      .setup(catalogController)
  );
};

export default ExerciseLibrary;
